<template>
  <div class="search-and-filters">
    <div v-if="groupingType !== 'my-uploads'" class="search-and-filters__section search-and-filters__section--search search-and-filters__section--flex-grow-1">
      <!-- Section title -->
      <div class="global-h5 section-title search-and-filters__section-title">
        <span class="section-title__search-word">Search</span> <span class="section-title__search-by-words">by {{ groupTypeText }}</span>
      </div>
      <!-- / Section title -->
      <div class="search-and-filters__section-content">
        <slot name="searchInput" />
      </div>
    </div>

    <div v-if="false" class="search-and-filters__section search-and-filters__section--source">
      <div class="global-h5 search-and-filters__section-title">Source</div>
      <div class="search-and-filters__section-content">
        <SrpCheckbox size="tiny" :isWithHalo="false">
          <template #input><slot name="creatorVisitsCheckbox" /></template>
          <template #text>{{ "Creator Visit" }}</template>
        </SrpCheckbox>
        <SrpCheckbox size="tiny" :isWithHalo="false">
          <template #input><slot name="communityUploadsCheckbox" /></template>
          <template #text>Community Uploads</template>
        </SrpCheckbox>
        <SrpCheckbox size="tiny" :isWithHalo="false">
          <template #input><slot name="myUploadsCheckbox" /></template>
          <template #text>My Uploads</template>
        </SrpCheckbox>
      </div>
    </div>

    <div
      :class="{
        'search-and-filters__section': true,
        'search-and-filters__section--horizontal': groupingType === 'my-uploads',
        'search-and-filters__section--content-type': true,
      }"
    >
      <div
        :class="{
          'global-h5': true,
          'search-and-filters__section-title': true,
          'search-and-filters__section-title--no-bottom-margin': groupingType === 'my-uploads',
        }"
      >
        Content type
      </div>
      <div class="search-and-filters__section-content">
        <SrpCheckbox size="tiny" :isWithHalo="false">
          <template #input><slot name="photosCheckbox" /></template>
          <template #text>Photos</template>
        </SrpCheckbox>
        <SrpCheckbox size="tiny" :isWithHalo="false">
          <template #input><slot name="videosCheckbox" /></template>
          <template #text>Videos</template>
        </SrpCheckbox>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

// Components
import SrpCheckbox from "@components/ui/SrpCheckbox.vue";

// Types
import { GroupingType } from "@contracts/photosPageData";

const props = withDefaults(
  defineProps<{
    customerId: string;
    groupingType: GroupingType | null;
  }>(),
  {
    customerId: "",
    groupingType: null,
  }
);

const groupTypeText = computed<string>(() => {
  let name: string = props.groupingType;
  if (props.groupingType === "community-upload") name = "community upload";
  if (props.groupingType === "adventure") name = "creator visit";

  return name;
});
</script>

<style scoped lang="scss">
@import "@/scss/screen-size-ranges.scss";

// Section title ==============================================================
.section-title {
  &__search-word {
  }

  &__search-by-words {
    font-weight: 400;
    white-space: nowrap;
  }
}
// desktop wide -----------------------
@media (min-width: $desktop-wide-min-width) {
}
// desktop ----------------------------
@media (min-width: $desktop-min-width) and (max-width: $desktop-max-width) {
}
// laptop -----------------------------
@media (min-width: $laptop-min-width) and (max-width: $laptop-max-width) {
}
// tablet large -----------------------
@media (min-width: $tablet-large-min-width) and (max-width: $tablet-large-max-width) {
}
// tablet -----------------------------
@media (min-width: $tablet-min-width) and (max-width: $tablet-max-width) {
}
// mobile -----------------------------
@media (max-width: $mobile-max-width) {
}

// Search & Filters ===========================================================
.search-and-filters {
  gap: 27px;
  padding: 20px 0 25px;
  display: flex;
  position: relative;
  z-index: 0;

  &::before {
    content: "";
    width: calc(100% + 50px);
    height: 100%;
    border-radius: 6px;
    position: absolute;
    inset: 0 auto auto -25px;
    z-index: -1;
    background: rgba(232, 232, 232, 1);
  }

  &__section {
    padding-right: 27px;
    border: 1px rgba(0, 0, 0, 0.15) solid;
    border-width: 0 1px 0 0;

    &:last-child {
      padding-right: 0;
      border-right: none;
    }

    &--horizontal {
      gap: 20px;
      display: flex;
      align-items: center;
    }

    &--search {
      flex-grow: 1;
      width: 608px;
      max-width: 608px;
    }
    &--source {
    }
    &--content-type {
    }
    &--upload-images-button {
      flex-grow: 1;
      display: flex;
      justify-content: flex-end;
    }
  }

  &__section-title {
    margin-bottom: 8px;

    &--no-bottom-margin {
      margin-bottom: 0;
    }
  }

  &__section-content {
    min-height: 40px;
    gap: 15px 30px;
    display: flex;
    flex-wrap: wrap;
  }
}
// desktop wide -----------------------
@media (min-width: $desktop-wide-min-width) {
}
// desktop ----------------------------
@media (min-width: $desktop-min-width) and (max-width: $desktop-max-width) {
  .search-and-filters {
    &__section {
      &--search {
        width: 623px;
        max-width: 623px;
      }
    }
  }
}
// laptop -----------------------------
@media (min-width: $laptop-min-width) and (max-width: $laptop-max-width) {
  .search-and-filters {
    &__section {
      &--search {
        width: 540px;
        max-width: 540px;
      }
    }
  }
}
// tablet large -----------------------
@media (min-width: $tablet-large-min-width) and (max-width: $tablet-large-max-width) {
  .search-and-filters {
    &__section {
      &--search {
        width: 548px;
        max-width: 548px;
      }
    }
  }
}
// tablet -----------------------------
@media (min-width: $tablet-min-width) and (max-width: $tablet-max-width) {
  .search-and-filters {
    gap: 15px;
    flex-direction: column;

    &::before {
      content: "";
      width: calc(100% + 50px);
      height: 100%;
      border-radius: 6px;
      position: absolute;
      inset: 0 auto auto -25px;
      z-index: -1;
      background: rgba(232, 232, 232, 1);
    }

    &__section {
      width: 100%;
      padding: 0 0 17px;
      border-width: 0 0 1px 0;

      &:last-child {
        padding: 0;
        border: none;
      }

      &--upload-images-button {
        justify-content: flex-start;
      }
    }

    &__section-content {
      min-height: unset;
    }
  }
}
// mobile -----------------------------
@media (max-width: $mobile-max-width) {
  .search-and-filters {
    gap: 15px;
    flex-direction: column;

    &::before {
      content: "";
      width: calc(100% + 50px);
      height: 100%;
      border-radius: 6px;
      position: absolute;
      inset: 0 auto auto -25px;
      z-index: -1;
      background: rgba(232, 232, 232, 1);
    }

    &__section {
      width: 100%;
      padding: 0 0 17px;
      border-width: 0 0 1px 0;

      &:last-child {
        padding: 0;
        border: none;
      }

      &--upload-images-button {
        justify-content: flex-start;
      }
    }

    &__section-content {
      min-height: unset;
    }
  }
}
</style>
